import { Card, CardBody, Col, Row } from 'reactstrap'
import { ticketData } from '../../../../Data/SupportTicket/SupportTicket'
import { H3, ProgressBar } from '../../../../AbstractElements'
import CountUp from "react-countup";
import ProfitAndLoss from './ProfitAndLoss';

const TicketList = () => {
  return (
    <Row>
      {ticketData.map((item, index) => (
        <Col xl="4" sm="6" className="box-col-6" key={index}>
          <Card className={`ecommerce-widget bg-light-${item.class} txt-${item.class} shadow-none`}>
            <CardBody className="support-ticket-font">
              <Row>
                <Col xs="5">
                  <span>{item.title}</span>
                  <H3 className="total-num counter"><CountUp end={item.num} /></H3>
                </Col>
                <ProfitAndLoss />
              </Row>
              <div className="progress-showcase mt-4">
                <ProgressBar className={`sm-progress-bar progress-striped-${item.class}`} striped animated color='transparent' value='70' />
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  )
}

export default TicketList